import portfolioData from '../../data/portfolioData';
import Reveal from '../Reveal/Reveal';
import './About.css';

const About = () => (
  <section className="section about" id="about">
    <div className="container">
      <div className="about__grid">
        <Reveal>
          <div className="section-head">
            <p className="section-eyebrow">About</p>
            <h2 className="section-title">Engineer. Builder. Shipper.</h2>
            <p className="section-lead">{portfolioData.about}</p>
          </div>
        </Reveal>

        <Reveal delay={1}>
          <div className="about__highlights" aria-label="Career highlights">
            {portfolioData.highlights.map((item) => (
              <div key={item.label} className="about__stat">
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>

      <Reveal delay={2}>
        <div className="about__services">
          {portfolioData.services.map((service) => (
            <article key={service.title} className="about__service">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </article>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
